import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import CustomButton, { CancelCustomButton } from '../custom-material/button/Button'
import CustomTypography from '../custom-material/typography/Typography'
import TextField from '@material-ui/core/TextField'

const styles = theme => ({
  dialog: {
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 16
  },
  fieldRowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12
  },
  fieldColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 12
  },
  fieldRowLabel: {
    marginRight: 8
  },
  fieldColumnLabel: {
    marginBottom: 8
  },
  input: {
    fontSize: '1em',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    borderBottom: 0,
    borderRadius: 2,
    marginTop: '28px !important'
  },
  inputText: {
    paddingLeft: 3
  },
  inputShrinkLabel: {
    color: 'black',
    fontWeight: 600,
    fontSize: '1.42em'
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12
  }
})

class RequestEmailEditDialogComponent extends React.PureComponent {
  render () {
    const { classes, dialogOpen, contact, newEmailAddress, handleChangeNewEmail, handleCloseDialog, requestEmailEdit } = this.props
    return (
      <CustomDialog classes={{paper: classes.dialog}} open={dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
        <CustomDialogTitle id='updates-dialog-title' disableTypography>Request Email Edit</CustomDialogTitle>
        <div className={classes.contentContainer}>
          <div className={classes.fieldRowContainer}>
            <strong className={classes.fieldRowLabel}>Name:</strong>
            <span>{contact.firstName} {contact.lastName}</span>
          </div>
          <div className={classes.fieldColumnContainer}>
            <strong className={classes.fieldColumnLabel}>Current Email Address:</strong>
            <span>{contact.emailAddress}</span>
          </div>
          <div className={classes.fieldRowContainer}>
            <TextField
              id='newEmailAddress'
              label='Enter your new email address:'
              required
              value={newEmailAddress || ''}
              error={!newEmailAddress}
              InputProps={{classes: {root: classes.input, input: classes.inputText}}}
              InputLabelProps={{shrink: true, classes: {shrink: classes.inputShrinkLabel}}}
              fullWidth
              onChange={handleChangeNewEmail}
            />
          </div>
          <div className={classes.fieldRowContainer}>
            <CustomTypography>
              {
                `*IPD Analytics does not accept personal
                email addresses or emails that go
                to distribution lists`
              }
            </CustomTypography>
          </div>
          <div className={classes.actionContainer}>
            <CancelCustomButton style={{marginRight: 8}} variant='contained' size='small' color='default'  onClick={handleCloseDialog}>Cancel</CancelCustomButton>
            <CustomButton disabled={!newEmailAddress} variant='contained' size='small' color='secondary'  onClick={() => { requestEmailEdit(contact.emailAddress, newEmailAddress); handleCloseDialog() }}>Submit</CustomButton>
          </div>
        </div>
      </CustomDialog>
    )
  }
}

RequestEmailEditDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  contact: PropTypes.object,
  newEmailAddress: PropTypes.string,
  handleChangeNewEmail: PropTypes.func,
  handleCloseDialog: PropTypes.func,
  requestEmailEdit: PropTypes.func
}

export default withStyles(styles)(RequestEmailEditDialogComponent)
